import styled from 'styled-components';
import { IconButton, Button } from '@perch-labs/shrike';
import { Container } from 'styles';

export const ActionButton = styled(IconButton)`
  margin: 0 8px;
  flex-shrink: 0;
`;

export const SignTermsButton = styled(Button)`
  padding: 8px;
`;

export const GroupHeader = styled(Container).attrs({
  flex: true,
  alignItems: 'center',
  justifyContent: 'space-between',
  margin: {
    top: '16px',
  },
  padding: {
    bottom: '16px',
  },
  border: {
    bottom: true,
  },
})``;

interface SpacerProps {
  incomplete?: boolean;
}

export const StyledSpacer = styled.div<SpacerProps>`
  padding: ${props => (props.incomplete ? '16px 0' : '0')};
`;
